module.exports = __webpack_public_path__ + "static/bright-2-d45c7429121b4c25d6a35c2aee456cd9.jpeg";